import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TeamJoinComponent } from './team-join.component';

const routes: Routes = [
  {
    path: '',
    component: TeamJoinComponent,
    title: 'Join Team'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TeamJoinRoutingModule {}
